import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { MySelect } from 'src/components/ui'
import { setSort } from 'src/redux/slices/propertySearchSlice'
import { RootState } from 'src/redux/store'

interface ISortSelect {
  showLabel?: boolean
  className?: string
}

// Newest / oldest / cheapest / most expensive. The choice lives in the store,
// so the map and the lists sort the same way. The system's select (white,
// framed, 44px), its label on the same line (it was the old lavender control).
const SortSelect: FC<ISortSelect> = ({ showLabel = true, className }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { sort } = useSelector((state: RootState) => state.propertySearch)

  return (
    <MySelect
      name="sort"
      isDefault
      wrapperClassName="!flex-row !items-center !gap-3 [&>span]:whitespace-nowrap"
      className={className}
      defaultValue={sort}
      label={showLabel ? `${t('sorting')}:` : undefined}
      options={[
        { label: t('sort.newest'), value: 'createdAt desc' },
        { label: t('sort.oldest'), value: 'createdAt asc' },
        { label: t('sort.cheapest'), value: 'price asc' },
        { label: t('sort.expensive'), value: 'price desc' },
      ]}
      onChange={(e) => {
        dispatch(setSort(e.value))
      }}
    />
  )
}

export default SortSelect
